import { gql, useMutation } from "@apollo/client";
import {
  Box,
  Button,
  Checkbox,
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import * as React from "react";
import { useState } from "react";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import CustomDialog from "../HOC/CustomComponents/CustomDialog";
import * as gqlb from "gql-query-builder";
import ButtonLoading from "../HOC/FunctionComponents/LoadingPages/ButtonLoading";
import config from "../../config.json";
import { useEffect } from "react";
import { Fragment } from "react";

export const COLLECTION_EXPOERT_SHIPMENTS = gqlb.mutation({
  operation: "exportCollectionEntries",
  fields: [],
  variables: {
    input: {
      type: "ExportCollectionEntriesInput",
      required: true,
    },
  },
});
export const PAYMENT_EXPOERT_SHIPMENTS = gqlb.mutation({
  operation: "exportPaymentEntries",
  fields: [],
  variables: {
    input: {
      type: "ExportPaymentEntriesInput",
      required: true,
    },
  },
});

export const INVOICE_EXPOERT_SHIPMENTS = gqlb.mutation({
  operation: "exportInvoiceShipments",
  fields: [],
  variables: {
    input: {
      type: "ExportInvoiceShipmentsInput",
      required: true,
    },
  },
});

const manifestDetails = (key) => {
  switch (key) {
    case "payment":
      return {
        storageVarName: "payment-export-shipments",
        query: PAYMENT_EXPOERT_SHIPMENTS,
        queryName: "exportPaymentEntries",
      };

    case "collection":
      return {
        storageVarName: "collection-export-shipments",
        query: COLLECTION_EXPOERT_SHIPMENTS,
        queryName: "exportCollectionEntries",
      };

    default:
      return {
        storageVarName: "invoice-export-shipments",
        query: INVOICE_EXPOERT_SHIPMENTS,
        queryName: "exportInvoiceShipments",
      };
  }
};

export default function ExportFinanceShipments(props) {
  const { id, disabled, type } = props;
  const manifestTypeDetails = manifestDetails(type);
  const storageVarName = manifestTypeDetails.storageVarName;

  const EXPOERT_SHIPMENTS = manifestTypeDetails.query;
  const [shipmentFieldsState, setShipmentFieldsState] = useState([]);
  const { t } = useTranslation();
  const shipmentFields = [
    { name: "CODE", label: t("code") },
    { name: "DATE", label: t("date") },
    { name: "STATUS", label: t("status") },
    { name: "BRANCH", label: t("branch") },
    {
      name: "ORIGIN_BRANCH",
      label: t("originBranch"),
    },
    {
      name: "SERVICE",
      label: t("service"),
    },
    { name: "SENDER_NAME", label: t("senderName") },
    { name: "SENDER_ZONE", label: t("senderZone") },
    {
      name: "SENDER_SUBZONE",
      label: t("senderSubzone"),
    },
    {
      name: "REFERENCE_NUMBER",
      label: t("refNumber"),
    },
    { name: "RECIPIENT_NAME", label: t("recipient") },
    {
      name: "RECIPIENT_ZONE",
      label: t("recipientZone"),
    },
    {
      name: "RECIPIENT_SUBZONE",
      label: t("recipientSubzone"),
    },
    {
      name: "RECIPIENT_ADDRESS",
      label: t("recipientAddress"),
    },
    {
      name: "RECIPIENT_PHONE",
      label: t("recipientPhone"),
    },
    {
      name: "RECIPIENT_MOBILE",
      label: t("recipientMobile"),
    },
    { name: "DESCRIPTION", label: t("description") },
    { name: "WEIGHT", label: t("weight") },
    { name: "PIECES_COUNT", label: t("pieceCount") },
    { name: "PRICE", label: t("packagePrice") },
    { name: "FEES", label: t("fees") },
    { name: "NET_AMOUNT", label: t("customerNet") },
    { name: "TOTAL_AMOUNT", label: t("totalCost") },
    {
      name: "DELIVERED_AMOUNT",
      label: t("deliveredAmount"),
    },
    {
      name: "COLLECTED_FEES",
      label: t("collectedFees"),
    },
    {
      name: "CUSTOMER_DUE",
      label: t("customerDueAmount"),
    },
    {
      name: "RETURN_DUE_FEES",
      label: t("returningDueFees"),
    },

    { name: "PRICE_TYPE", label: t("priceType") },
    {
      name: "DELIVERY_TYPE",
      label: t("deliveryType"),
    },
    { name: "RETURN_TYPE", label: t("returnType") },
    {
      name: "DELIVERY_AGENT",
      label: t("deliveryAgent"),
    },
    { name: "COLLECTED", label: t("collected") },
    { name: "PAID", label: t("paidToCustomer") },
    { name: "NOTES", label: t("notes") },
    {
      name: "OPENABLE",
      label: t("packageOpenPossibility"),
    },
    { name: "CUSTOMER", label: t("customer") },
    {
      name: "CANCELLATION_REASON",
      label: t("CancellationReasonName"),
    },
    {
      name: "TYPE",
      label: t("packageType"),
    },
    {
      name: "ATTEMPTS",
      label: t("attempts"),
    },
  ];
  useEffect(() => {
    switch (type) {
      case "payment":
        shipmentFields.splice(
          shipmentFields.length,
          { name: "PAYMENT_TYPE", label: t("paymentType") },
          {
            name: "PAID_AMOUNT",
            label: t("customerDueAmount"),
          }
        );
        break;

      case "collection":
        shipmentFields.splice(
          shipmentFields.length,
          { name: "PAYMENT_TYPE", label: t("paymentType") },
          {
            name: "COLLECTED_AMOUNT",
            label: t("collectedAmount"),
          }
        );
        break;

      default:
        shipmentFields.splice(
          shipmentFields.length,
          0,
          {
            name: "DELIVERY_FEES",
            label: t("deliveryFees"),
          },
          {
            name: "POST_FEES",
            label: t("postFees"),
          },
          {
            name: "TAX",
            label: t("tax"),
          }
        );
        break;
    }

    if (!shipmentFields[0].id)
      shipmentFields.forEach((ele, index) => {
        ele["id"] = index + 1;
        ele["checked"] = true;
      });

    const localStorageExportShipment = localStorage.getItem(storageVarName);
    const parsedExportShipment = localStorageExportShipment
      ? JSON.parse(localStorageExportShipment)
      : null;

    const notCheckedFields = shipmentFields.filter((i) => {
      if (
        !parsedExportShipment?.includes(i.name) &&
        parsedExportShipment !== null
      ) {
        i.checked = false;
        return true;
      }
      return false;
    });

    const checkedFields = shipmentFields.filter((i) => {
      if (parsedExportShipment?.includes(i.name)) {
        i.checked = true;
        return true;
      }
      return false;
    });

    const sortedFields = checkedFields.sort((a, b) => {
      return parsedExportShipment?.indexOf(a.name) >
        parsedExportShipment?.indexOf(b.name)
        ? 1
        : -1;
    });

    setShipmentFieldsState(
      localStorageExportShipment
        ? [...sortedFields, ...notCheckedFields]
        : shipmentFields
    );
    return () => { };
  }, [t]);

  const [dialogState, setDialogState] = useState(false);

  const fieldCount = shipmentFieldsState.length;
  const fieldSelected = shipmentFieldsState.filter((i) => i.checked).length;
  const onSelectAllClick = (e) => {
    const fileds = [...shipmentFieldsState];
    fileds.forEach((i) => {
      if (e.target.checked) {
        i.checked = true;
      } else {
        i.checked = false;
      }
    });
    setShipmentFieldsState(fileds);
  };

  const onCloseDialog = () => {
    setDialogState(false);
  };

  const onOpenDialog = () => {
    setDialogState(true);
  };

  let getBackendUri = (path) => {
    const domain = config.backend.domain
      ? config.backend.domain
      : window.location.hostname;

    return `${config.backend.protocol}://${domain}:${config.backend.port}/${path}`;
  };

  const [exportShipments, { loading }] = useMutation(
    gql`
      ${EXPOERT_SHIPMENTS.query}
    `,
    {
      onCompleted: (data) => {
        const path = data?.[manifestTypeDetails.queryName];
        onCloseDialog();
        window.open(getBackendUri(path));
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(shipmentFieldsState);
    const [reorderedItem] = items.splice(result.source.index, 1);
    const isNotChecked = items[result.destination.index - 1]?.checked;
    if (isNotChecked === false) return;
    items.splice(result.destination.index, 0, reorderedItem);

    setShipmentFieldsState(items);
  }

  const handelExportShipment = () => {
    const updatedFields = shipmentFieldsState.reduce((previous, current) => {
      if (current.checked) {
        previous.push(current.name);
      }
      return previous;
    }, []);
    localStorage.setItem(storageVarName, JSON.stringify(updatedFields));
    const fields = shipmentFieldsState
      .filter((i) => i.checked)
      .map((i) => ({ label: i.label, name: i.name }));
    exportShipments({
      variables: {
        input: {
          id: parseInt(id),
          ...(type === 'payment' ? { shipmentFields: fields } : {fields})
        },
      },
    });
  };

  return (
    <>
      <Tooltip title={t("exportExcel")}>
        <Box component="span">
          <IconButton
            disabled={disabled}
            onClick={() => onOpenDialog()}
            size="large"
          >
            <Icon sx={{ fontFamily: "Material Icons Outlined" }}>
              sim_card_download
            </Icon>
          </IconButton>
        </Box>
      </Tooltip>
      <CustomDialog
        fullWidth
        maxWidth="xs"
        open={dialogState}
        onClose={onCloseDialog}
        title={
          <Fragment>
            <Checkbox
              edge="start"
              indeterminate={fieldSelected > 0 && fieldSelected < fieldCount}
              checked={fieldCount > 0 && fieldSelected === fieldCount}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "select all desserts" }}
            />
            {t("exportExcel")}
          </Fragment>
        }
        actions={
          <>
            <Button color="primary" onClick={onCloseDialog}>
              {t("cancel")}
            </Button>
            <Button
              color="primary"
              disabled={loading || fieldSelected === 0}
              onClick={handelExportShipment}
            >
              {loading ? <ButtonLoading /> : t("confirm")}
            </Button>
          </>
        }
        content={
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="characters">
              {(provided) => (
                <List
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  component="ul"
                  sx={{
                    width: "100%",
                    bgcolor: "background.paper",
                  }}
                >
                  {/* <ListItem dense button>
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      indeterminate={
                        fieldSelected > 0 && fieldSelected < fieldCount
                      }
                      checked={fieldCount > 0 && fieldSelected === fieldCount}
                      onChange={onSelectAllClick}
                      inputProps={{ "aria-label": "select all desserts" }}
                    />
                  
                  </ListItemIcon>
                  <ListItemText primary={t("selectAll")} />
                </ListItem> */}

                  {shipmentFieldsState.map((value, index) => {
                    const labelId = `checkbox-list-label-${value.id}`;
                    return (
                      <Draggable
                        isDragDisabled={!value.checked}
                        key={value.id}
                        draggableId={value.name}
                        index={index}
                      >
                        {(provided) => (
                          <CustomeItemList
                            innerRef={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            itemDetails={value}
                            labelId={labelId}
                            state={shipmentFieldsState}
                            setState={setShipmentFieldsState}
                          />
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.label}
                </List>
              )}
            </Droppable>
          </DragDropContext>
        }
      />
    </>
  );
}

const CustomeItemList = (props) => {
  const { itemDetails, labelId, state, setState, innerRef, ...restProps } =
    props;
  const { label, checked } = itemDetails;
  // const [checkboxState,setCheckboxState] = React.state(checked)
  const handleToggle = (e) => {
    const checked = e.target.checked;
    const update = [...state];
    const checkedItemLength = update.filter((i) => i.checked).length;
    const index = update.findIndex((i) => i.name === itemDetails.name);
    const [sortItem] = update.splice(index, 1);

    sortItem["checked"] = checked;
    update.splice(checkedItemLength, 0, sortItem);

    setState(update);
  };
  return (
    <ListItem {...restProps} ref={innerRef} dense button>
      <ListItemIcon>
        <Checkbox
          edge="start"
          checked={checked}
          tabIndex={-1}
          onChange={handleToggle}
          disableRipple
          inputProps={{ "aria-labelledby": labelId }}
        />
      </ListItemIcon>
      <ListItemText id={labelId} primary={label} />
    </ListItem>
  );
};
